export const SET_CHANGEPASSWORD = 'SET_CHANGEPASSWORD';
